import React from "react";
import "../styles/components/loaderComponent.css"; // Assuming you have a directory for common styles

import loader from "../assets/images/loader.gif";

const LoaderComponent = () => {
  return (
    <div className="loaderContainer">
      <img src={loader} alt="Loading..." className="loaderImage" />
    </div>
  );
};

export default LoaderComponent;
